<script>
    import notificacaoServico from '~modulos/notificacoes/servico';
    import tipoUsuario from '~js/tipo-usuario';
    import CardNotificacao from './CardNotificacao.vue';
    import CardAviso from './CardAviso.vue';

    import 'select2';
    import 'select2/dist/js/i18n/pt-BR';

    export default {
      components: { CardNotificacao, CardAviso },
      data() {
        return {
          usuario: this.$storage.usuario(),
          tipoUsuario: tipoUsuario,
          configuracao: this.$storage.configuracao(),
          notificacoes: [],
          solicitacoes: [],
          mensagens: [],
          pedidos: [],
          pesquisasPrecoAprovacao: [],
          pesquisasPassagemAprovacao: [],
          projetosTerminando: [],
          quantidadePedidos: 0,
          quantidadePesquisasNaoAprovadas: 0,
          quantidadeProjetosTerminando: 0,
          mostrarSolicitacoes: false,

          carregandoSolicitacao: false,
          carregandoMensagem: false,
          carregandoPedidos: false,
          carregandoPesquisasPrecoAprovacao: false,
          carregandoPesquisasPassagemAprovacao: false,
          carregandoProjetosTerminando: false,

          filtroMensagem:{
            modulo: '0',
            idProjeto: '0',
            mostrarMensagens: '1',
            numero: '',
          },
          carregando: false,
        }
      },
      methods: {
        retornaDescricao(modulo){
          switch (modulo) {
            // Compras;
            case 1:
              return "Solicitação de Compra";
            // Solicitação de bolsas, RPA ou estágio
            case 2:
              return 'Solicitação de ' + this.configuracao.nomeModuloSolContratos;
            //Curso, evento ou serviço
            case 3:
              return "Solicitação de Curso, Evento, Doação ou Serviço";
            //Solicitação de Pagamento Pessoa Física
            case 4:
              return "Solicitação de Pagamento Pessoa Física";
            //Solicitação de Adiantamento
            case 5:
              return "Solicitação de Adiantamento";
            //Solicitação de Passagens, Diárias e Adiantamento
            case 6:
              let passagem = this.configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '';
              let adiantamento = this.configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '';

              return 'Solicitação de Diária ' + passagem + adiantamento;
            //Solicitação Faturamento
            case 7:
              return "Solicitação de Faturamento";
            //Solicitação Faturamento Multiserviços
            case 8:
              return "Solicitação de Importação";
            //Solicitação Pagamento Pessoa Jurídica
            case 9:
              return "Solicitação de Pagamento Pessoa Jurídica";
            //Solicitação Reembolso Terceiro
            case 10:
              return "Solicitação de Reembolso Terceiro";
            //Solicitação de Pagamento Estrangeiro PF
            case 13:
              return "Solicitação de Pagamento Estrangeiro PF";
            //Solicitação de Pagamento Estrangeiro PJ
            case 14:
              return "Solicitação de Pagamento Estrangeiro PJ";
            //Solicitação de Transferência
            case 15:
              return "Solicitação de Transferência";
            //Solicitação de Cancelamento Contrato
            case 16:
              return "Solicitação de Cancelamento Contrato";
          }

          return;
        },
        retornaClass(modulo) {
          switch (modulo) {
            // Compras;
            case 1:
              return "fa fa-shopping-basket compras";
            // Solicitação de bolsas, RPA ou estágio
            case 2:
              return "fa fa-address-card bolsarpaestagio";
            //Curso, evento ou serviço
            case 3:
              return "fa fa-graduation-cap cursoeventoservico";
            //Solicitação de Pagamento Pessoa Física
            case 4:
              return "fa fa-money solpf";
            //Solicitação de Adiantamento
            case 5:
              return "fa fa-money adiantamento";
            //Solicitação de Passagens, Diárias e Adiantamento
            case 6:
              return "fa fa-plane reembolso";
            //Solicitação Faturamento
            case 7:
              return "fa fa-calculator faturamento";
            //Solicitação De Importação
            case 8:
              return "fa fa-ship solImportacao";
            //Solicitação Pagamento Pessoa Jurídica
            case 9:
              return "fa fa-money solpj";
            //Solicitação Reembolso Terceiro
            case 10:
              return "fa fa-money reembolsoterceiro";
            // Pedidos para liberação;
            case 11:
              return "fa fa-shopping-cart pedidos";
            // Pesquisas de compra aprovação;
            case 12:
              return "fa fa-list-alt pesquisas";
            case 13:
              return "fa fa-money solpf";
            case 14:
              return "fa fa-money solpj";
            case 15:
              return "fa fa-refresh soltransferencia";
            case 16:
              return "fa fa-address-card-o solcancelamentocontrato";
            // Projetos Terminando
            case 17:
              return "fa fa-list-alt pesquisas";
          }

          return;
        },
        listaNotificacoes() {
          if (!this.mensagemSistema)
            return;

          this.carregandoMensagem = true;

          return notificacaoServico.
            listaNotificacoes()
            .then(res => {
              this.carregandoMensagem = false;
              this.notificacoes = res;

              for (var i = 0; i < this.notificacoes.length; i++) {
                let notificacao = this.notificacoes[i];

                switch (notificacao.tipoNotificacao) {
                  case 1:
                    let auxNotificacao = {
                      descricao: this.retornaDescricao(notificacao.modulo),
                      quantidade: notificacao.quantidade,
                      modulo: notificacao.modulo,
                    }

                    this.mensagens.push(auxNotificacao);
                    break;
                  case 2:
                    break;
                }
              }

            });
        },
        listaPedidosNaoLiberados() {
          if (!this.pedidosCompra)
            return;

          this.carregandoPedidos = true;

          return notificacaoServico.
            listaPedidosNaoLiberados()
            .then(res => {
              this.carregandoPedidos = false;
              this.quantidadePedidos = res;

              if (parseInt(this.quantidadePedidos) > 0) {
                let auxNotificacao = {
                  descricao: "Pedidos de compras pendente de liberação",
                  quantidade: this.quantidadePedidos,
                  modulo: 11,
                }

                this.pedidos.push(auxNotificacao);
              }
            });
        },
        listaPesquisasNaoAprovadas() {
          if (!this.aprovacaoPesquisaPreco)
            return;

          this.carregandoPesquisasPrecoAprovacao = true;

          return notificacaoServico.
            listaPesquisasNaoAprovadas()
            .then(res => {
              this.carregandoPesquisasPrecoAprovacao = false;
              this.quantidadePesquisasNaoAprovadas = res;

              if (parseInt(this.quantidadePesquisasNaoAprovadas) > 0) {
                let auxNotificacao = {
                  descricao: "Pesquisas de preço pendente de aprovação",
                  quantidade: this.quantidadePesquisasNaoAprovadas,
                  modulo: 12,
                }

                this.pesquisasPrecoAprovacao.push(auxNotificacao);
              }
            });
        },
        listaPesquisasPassagemNaoAprovadas() {
          if (!this.aprovacaoPesquisaPreco)
            return;

          this.carregandoPesquisasPassagemAprovacao = true;

          return notificacaoServico.
            listaPesquisasPassagemNaoAprovadas()
            .then(res => {
              this.carregandoPesquisasPassagemAprovacao = false;
              this.quantidadePesquisasNaoAprovadas = res;

              if (parseInt(this.quantidadePesquisasNaoAprovadas) > 0) {
                let auxNotificacao = {
                  descricao: "Pesquisas de passagem pendente de aprovação",
                  quantidade: this.quantidadePesquisasNaoAprovadas,
                  modulo: 6,
                }

                this.pesquisasPassagemAprovacao.push(auxNotificacao);
              }
            });
        },
        listaProjetosTerminando() {
          this.carregandoProjetosTerminando = true;

          return notificacaoServico.
            listaProjetosTerminando()
            .then(res => {
              this.carregandoProjetosTerminando = false;
              this.quantidadeProjetosTerminando = res;

              if (parseInt(this.quantidadeProjetosTerminando) > 0) {
                let auxNotificacao = {
                  descricao: "Projetos terminando",
                  quantidade: this.quantidadeProjetosTerminando,
                  modulo: 17,
                }

                this.projetosTerminando.push(auxNotificacao);
              }
            });
        },
        listaNotificacoesSolicitacoes() {
          if (!this.liberarSolicitacoes)
            return;

          this.carregandoSolicitacao = true;

          return notificacaoServico.
            listaNotificacoesSolicitacoes()
            .then(res => {
              this.carregandoSolicitacao = false;
              this.notificacoes = res;

              if (this.notificacoes.solAdiantamento.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solAdiantamento[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solAdiantamento.length,
                  modulo: this.notificacoes.solAdiantamento[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solBolsa.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solBolsa[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solBolsa.length,
                  modulo: this.notificacoes.solBolsa[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solCompra.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                    descricao: this.retornaDescricao(this.notificacoes.solCompra[0].tipoSolicitacao),
                    quantidade: this.notificacoes.solCompra.length,
                    modulo: this.notificacoes.solCompra[0].tipoSolicitacao,
                  }

                  this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solCursoEventoServicoDoacao.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solCursoEventoServicoDoacao[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solCursoEventoServicoDoacao.length,
                  modulo: this.notificacoes.solCursoEventoServicoDoacao[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solReembolso.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solReembolso[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solReembolso.length,
                  modulo: this.notificacoes.solReembolso[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solFaturamento.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solFaturamento[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solFaturamento.length,
                  modulo: this.notificacoes.solFaturamento[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solFaturamentoMC.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solFaturamentoMC[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solFaturamentoMC.length,
                  modulo: this.notificacoes.solFaturamentoMC[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solPagamentoPF.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solPagamentoPF[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solPagamentoPF.length,
                  modulo: this.notificacoes.solPagamentoPF[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solPagamentoPJ.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solPagamentoPJ[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solPagamentoPJ.length,
                  modulo: this.notificacoes.solPagamentoPJ[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if ((this.notificacoes.solPagamentoEstrangeiroPF.length > 0) && this.configuracao.solPgtoPFEstrangeiro) {
                this.mostrarSolicitacoes = true;
                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solPagamentoEstrangeiroPF[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solPagamentoEstrangeiroPF.length,
                  modulo: this.notificacoes.solPagamentoEstrangeiroPF[0].tipoSolicitacao,
                }
                this.solicitacoes.push(auxNotificacao);
              }

              if ((this.notificacoes.solPagamentoEstrangeiroPJ.length > 0) && this.configuracao.solPgtoPJEstrangeiro) {
                this.mostrarSolicitacoes = true;
                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solPagamentoEstrangeiroPJ[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solPagamentoEstrangeiroPJ.length,
                  modulo: this.notificacoes.solPagamentoEstrangeiroPJ[0].tipoSolicitacao,
                }
                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solReembolsoTerceiro.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solReembolsoTerceiro[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solReembolsoTerceiro.length,
                  modulo: this.notificacoes.solReembolsoTerceiro[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solTransferencia.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solTransferencia[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solTransferencia.length,
                  modulo: this.notificacoes.solTransferencia[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solCancelamentoContrato.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solCancelamentoContrato[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solCancelamentoContrato.length,
                  modulo: this.notificacoes.solCancelamentoContrato[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

              if (this.notificacoes.solImportacao.length > 0) {
                this.mostrarSolicitacoes = true;

                let auxNotificacao = {
                  descricao: this.retornaDescricao(this.notificacoes.solImportacao[0].tipoSolicitacao),
                  quantidade: this.notificacoes.solImportacao.length,
                  modulo: this.notificacoes.solImportacao[0].tipoSolicitacao,
                }

                this.solicitacoes.push(auxNotificacao);
              }

            });
        },
      },
      mounted() {
        this.$root.tituloDaPagina = `Notificações`;
        this.$root.botaoAcaoMostrar = false;

        this.$root.botaoRetrocederMostrar = false;
        this.$root.botaoRetrocederRota = '';

        const _this = this;
      },
      computed: {
        coordenador() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador;
        },
        aluno() {
          return this.usuario.tipoUsuario === tipoUsuario.Aluno;
        },
        fornecedor() {
          return this.usuario.tipoUsuario === tipoUsuario.Fornecedor;
        },
        solCompras() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && this.configuracao.solCompras && this.usuario.permissoes.solCompras;
        },
        solBolsa() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && this.configuracao.solBolsa && this.usuario.permissoes.solBolsa;
        },
        solCursoEventoServico() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && this.usuario.permissoes.solCursoEventoServico;
        },
        liberarSolicitacoes() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && (this.usuario.permissoes.liberarSolWEB1 ||
                                                                          this.usuario.permissoes.liberarSolWEB2);
        },
        mensagemSistema() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && (
            (this.solBolsa) ||
            (this.solCompras) ||
            (this.solCursoEventoServico) ||
            (this.solTransferencia) ||
            (this.solPagamentoPessoaFisica) ||
            (this.solPagamentoPessoaJuridica) ||
            (this.solReembolso) ||
            (this.solFaturamento) ||
            (this.solReembolsoTerceiro) ||
            (this.solAdiantamento)
          ) && !this.configuracao.naoUtilizarMensageria;
        },
        pedidosCompra() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador &&
                          this.usuario.permissoes.liberarPedidoCompra &&
                          this.configuracao.utilizarLiberacaoPedidoCoordenador;
        },
        aprovacaoPesquisaPreco() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador &&
            this.usuario.permissoes.aprovarPesquisaPreco &&
            this.configuracao.utilizarAprovacaoPesquisaPreco;
        },
        mostraProjetosTerminando() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && this.quantidadeProjetosTerminando > 0;
        },
      },
      created() {
        this.listaNotificacoes();
        this.listaNotificacoesSolicitacoes();
        this.listaPedidosNaoLiberados();
        this.listaPesquisasNaoAprovadas();
        this.listaPesquisasPassagemNaoAprovadas();
        this.listaProjetosTerminando();
      },
    }
</script>

<template>
    <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
        <div class="row" v-if="configuracao.mensagemAvisoGeral">
            <div class="col-lg-12">
                <div class="ibox float-e-margins">
                    <card-aviso :titleCard="'Aviso'"
                                :texto="configuracao.mensagemAvisoGeral">
                    </card-aviso>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox float-e-margins">
                    <card-notificacao v-if="liberarSolicitacoes"
                                      :itens="solicitacoes"
                                      :carregando="carregandoSolicitacao"
                                      :titleCard="'Solicitações pendentes de liberação'"
                                      :rotaBotao="{ name: 'liberar-solicitacoes' }"
                                      :textoBotao="'Acessar liberação'"
                                      :semItemTexto="'Sem solicitações pendentes de liberação'">
                    </card-notificacao>

                    <card-notificacao v-if="mensagemSistema"
                                      :itens="mensagens"
                                      :carregando="carregandoMensagem"
                                      :titleCard="'Mensagens pendentes de leitura'"
                                      :rotaBotao="{ name: 'mensagem', params: { filtrosBag : filtroMensagem } }"
                                      :textoBotao="'Acessar mensagens'"
                                      :semItemTexto="'Sem mensagens pendentes de leitura'">
                    </card-notificacao>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox float-e-margins">
                    <card-notificacao v-if="mostraProjetosTerminando"
                                      :itens="projetosTerminando"
                                      :carregando="carregandoProjetosTerminando"
                                      :titleCard="'Projetos terminando'"
                                      :rotaBotao="{ name: 'termino-projetos' }"
                                      :textoBotao="'Acessar projetos terminando'"
                                      :semItemTexto="'Sem projetos terminando'">
                    </card-notificacao>

                    <card-notificacao v-if="pedidosCompra"
                                      :itens="pedidos"
                                      :carregando="carregandoPedidos"
                                      :titleCard="'Pedidos pendentes de liberação'"
                                      :rotaBotao="{ name: 'liberar-pedidos-compra' }"
                                      :textoBotao="'Acessar liberação pedidos'"
                                      :semItemTexto="'Sem pedidos de compra pendentes de liberação'">
                    </card-notificacao>

                    <card-notificacao v-if="aprovacaoPesquisaPreco"
                                      :itens="pesquisasPrecoAprovacao"
                                      :carregando="carregandoPesquisasPrecoAprovacao"
                                      :titleCard="'Pesquisas de preço pendentes de aprovação'"
                                      :rotaBotao="{ name: 'aprovar-pesquisa-preco' }"
                                      :textoBotao="'Acessar aprovação pesquisas de preço'"
                                      :semItemTexto="'Sem pesquisas de preço pendentes de aprovação'">
                    </card-notificacao>

                    <card-notificacao v-if="aprovacaoPesquisaPreco"
                                      :itens="pesquisasPassagemAprovacao"
                                      :carregando="carregandoPesquisasPassagemAprovacao"
                                      :titleCard="'Pesquisas de passagens pendentes de aprovação'"
                                      :rotaBotao="{ name: 'aprovar-passagem' }"
                                      :textoBotao="'Acessar aprovação pesquisas de passagem'"
                                      :semItemTexto="'Sem pesquisas de passagens pendentes de aprovação'">
                    </card-notificacao>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/notificacoes/componentes/Notificacao.vue